export const SRHT_EXAM_REGULATION_CONTENT = {
  title: 'Ausbildungs- & Prüfungsordnung',
  subtitle: 'Ausbildungs- & Prüfungsordnung für Höhenretter/-*innen der Feuerwehr Düsseldorf',
  source: 'Anhang der Dienstanweisung Absturzsicherung & Höhenrettung vom 01.12.2022',
  referenceDocument: {
    label: 'PDF herunterladen',
    href: '/pruefung-srht/ausbildungs-und-pruefungsordnung-srht.pdf',
    filename: 'Ausbildungs-und-Pruefungsordnung-SRHT-Feuerwehr-Duesseldorf.pdf',
  },
  quickFacts: [],
  sections: [
    {
      id: 'geltungsbereich-personalauswahl',
      title: '1. Geltungsbereich & Personalauswahl',
      defaultExpanded: true,
      children: [
        {
          id: 'geltungsbereich',
          title: '1.1. Geltungsbereich',
          paragraphs: [
            'Diese Ausbildungs- & Prüfungsordnung gilt für die Ausbildung & Prüfung „Spezielle Rettung aus Höhen & Tiefen“. Sie ist bindend für alle Teilnehmer*innen des Lehrganges, unabhängig der entsendenden Stelle.',
          ],
        },
        {
          id: 'personalauswahl',
          title: '1.2. Personalauswahl',
          paragraphs: [
            'Die Voraussetzungen zur Bewerbung wird jährlich per Mitarbeiterinformation bekannt gegeben. Die Personalauswahl wird durch 37/4, gemeinsam mit dem/der Leiter*in der Höhenrettung, dem/der Fachgruppenleiter*in Höhenrettung und den Lehrhöhenretter*innen „Ausbildung“, unter Würdigung aller Begleitumstände getroffen.',
            'Für Teilnehmer*innen, die nicht der Feuerwehr Düsseldorf angehören, entscheidet die entsendende Stelle über eine Teilnahme.',
            'Zuvor wird durch die Lehrhöhenretter „Ausbildung“ ein Eignungsverfahren durchgeführt. Das Verfahren ist an die Empfehlung der AGBF – Spezielle Rettung aus Höhen & Tiefen angelehnt.',
            'Bei der Durchführung des Eignungsverfahren unterstützen die anderen Lehrhöhenretter.',
            'Anhand der festgestellten Kompetenzen wird einvernehmlich durch die anwesenden Lehrhöhenretter*innen über die Eignung entschieden. Bei Stimmgleichheit entscheidet der/die Fachgruppenleiter*in Höhenrettung. Um die Entscheidung nachvollziehbar zu gestalten werden die erzielte Leistung und Kompetenzen auf einem Bewertungsbogen festgehalten und ausgewertet.',
            'Das Ergebnis des Eignungsverfahren ist schriftlich festzuhalten.',
            'Durch den Personalrat ist nach Möglichkeit ein/eine Beobachter*in zu entsenden.',
            'Ebenso ist die Gleichstellungsvertretung einzuladen, bei einer Teilnahme von weiblichen Personen.',
            'Ohne festgestellte Eignung ist eine Teilnahme am Lehrgang nicht möglich, unabhängig der entsendenden Stelle.',
          ],
        },
      ],
    },
    {
      id: 'ausbildung-und-allgemeine-pruefungsbestimmungen',
      title: '2. Ausbildung & allgemeine Prüfungsbestimmungen',
      defaultExpanded: true,
      children: [
        {
          id: 'gliederung-der-ausbildung',
          title: '2.1. Gliederung der Ausbildung',
          paragraphs: [
            'Die Dauer der Ausbildung umfasst 120 Stunden.',
            'Der Inhalt der Ausbildung ergibt sich aus dem aktuell gültigen Musterausbildungsplan zur Grundausbildung in der speziellen Rettung aus Höhen & Tiefen. Dieser orientiert sich an der Empfehlung der AGBF – Spezielle Rettung aus Höhen & Tiefen.',
            'Der/Die Fachgruppenleiter*in Höhenrettung übernimmt die Funktion der Lehrgangsleitung. Er/Sie wird durch alle weiteren Lehrhöhenretter*innen unterstützt. Zur Vermittlung spezieller Unterrichtseinheiten können weitere Dozent*innen mit eingebunden werden.',
            'Während der Dauer der Ausbildung erhält jede/jeder Teilnehmer*in zwei Feedbackgespräche, damit die persönliche Einschätzung der bisher erbrachten Leistung mit den Beobachtungen der Lehrhöhenretter abgeglichen werden kann. Die Anzahl der Feedbackgespräche kann durch die Lehrgangsleitung bei Bedarf erhöht werden. Die Durchführung der Feedbackgespräche liegt in der Verantwortung der Lehrgangsleitung. Bei Bedarf wird der/die Leiter*in der Höhenrettung hinzugezogen.',
          ],
        },
        {
          id: 'pruefungskommission',
          title: '2.2. Prüfungskommission',
          beforeGroupsParagraphs: [
            'Die Prüfung wird vor einer Kommission abgelegt. Diese besteht aus vier stimmberechtigten Personen. Zu jeder Prüfung wird der Personalrat, Abteilung 37/4 und die Gleichstellungsvertretung (bei Teilnahme einer weiblichen Person) eingeladen:',
          ],
          groups: [
            {
              title: '',
              items: [
                'Prüfungsvorsitzender*in: Leiter*in der Höhenrettung oder Vertreter*in mit Fachexpertise',
                '1. Beisitzer*in: Lehrgangsleiter*in',
                '2. Beisitzer*in: Lehrhöhenretter*innen aus dem zu prüfenden Lehrgang',
                '3. Beisitzer*in: Lehrhöhenretter*innen aus dem zu prüfenden Lehrgang',
                'Beobachter*in: Personalrat der Feuerwehr Düsseldorf (optional)',
                'Beobachter*in: Abteilung 37/4 (optional)',
                'Beobachter*in: Gleichstellungsvertretung (optional)',
              ],
            },
          ],
          afterGroupsParagraphs: [
            'Die Prüfungskommission entscheidet einvernehmlich. Bei Stimmgleichheit entscheidet der/die Prüfungsvorsitzende. Jede Funktion der Prüfungskommission muss besetzt sein. Die Bildung von Personalunionen ist nicht zulässig.',
            'Der Personalrat vertritt die Interessen des Prüflings, unabhängig deren Zugehörigkeit, und achtet auf die korrekte Durchführung der Prüfung im Sinne dieser Ordnung.',
            'Prüflinge, die nicht der Feuerwehr Düsseldorf angehören können um das Beiwohnen weiterer Beobachter*innen bitten. Hierüber entscheidet der/die Lehrgangsleiter*in.',
          ],
        },
        {
          id: 'zulassung-zur-pruefung',
          title: '2.3. Zulassung zur Prüfung',
          paragraphs: [
            'Zur Prüfung zugelassen wird, wer nicht mehr als 10% der Gesamtausbildung versäumt hat und aufgrund des Lehrgangsverlaufs erkennen lässt, dass er/sie die nötigen Grundkenntnisse und persönliche Eignung besitzt.',
            'Die Entscheidung über die beiden letzten Punkte trifft der/die Leiter*in der Höhenrettung gemeinsam mit dem/der Lehrgangsleiter*in. Hierfür ist der/die Leiter*in der Höhenrettung regelmäßig über die Leistung der einzelnen Teilnehmer*innen zu informieren. Die am Lehrgang beteiligten Lehrhöhenretter*innen sind anzuhören.',
            'Sollte ein Prüfling, aufgrund von mangelhaften Grundkenntnissen und/oder persönlicher Eignung nicht zugelassen werden, ist die Begründung schriftlich der Lehrgangsakte beizufügen. Der Prüfling ist zeitnah zu unterrichten, sobald eine Zulassung zur Prüfung nicht mehr möglich ist.',
          ],
        },
        {
          id: 'niederschrift',
          title: '2.4. Niederschrift',
          paragraphs: [
            'Die Durchführung der Ausbildung und Prüfung wird in einer Lehrgangsakte niedergelegt.',
          ],
        },
        {
          id: 'benotung-der-pruefung',
          title: '2.5. Benotung der Prüfung',
          paragraphs: [
            'Es werden nur ganze Noten vergeben. Die Endnote wird bis zwei Stellen hinter dem Komma auf, oder abgerundet. Bei mehr als 0,49 wird aufgerundet. In allen anderen Fällen wird abgerundet.',
            'Zur Notenermittlung wird der IHK-Notenschlüssel NRW in Verbindung der Noten-/Punktstufen der VAP 1.2-Feu § 5 genutzt.',
          ],
          groups: [
            {
              title: '',
              items: [
                '„sehr gut“ (15 bis 14 Punkte), wenn die Leistung den Anforderungen in besonderem Maße entspricht.',
                '„gut“ (13 bis 11 Punkte), wenn die Leistung den Anforderungen voll entspricht.',
                '„befriedigend“ (10 bis 8 Punkte), wenn die Leistung im Allgemeinen den Anforderungen entspricht.',
                '„ausreichend“ (7 bis 5 Punkte), wenn die Leistung zwar Mängel aufweist, aber im Ganzen den Anforderungen noch entspricht.',
                '„mangelhaft“ (4 bis 2 Punkte), wenn die Leistung den Anforderungen nicht entspricht, jedoch erkennen lässt, dass die notwendigen Grundkenntnisse vorhanden sind und die Mängel in absehbarer Zeit behoben werden können.',
                '„ungenügend“ (1 bis 0 Punkte), wenn die Leistung den Anforderungen nicht entspricht und selbst die Grundkenntnisse so lückenhaft sind, dass die Mängel in absehbarer Zeit nicht behoben werden können.',
              ],
            },
          ],
        },
        {
          id: 'bestehen-der-pruefung',
          title: '2.6. Bestehen der Prüfung',
          paragraphs: [
            'Es werden nur ganze Noten vergeben.',
            'Die Prüfung gilt als bestanden, wenn die Gesamtnote mindestens „ausreichend“ (mindestens 5 Punkte) lautet und in den insgesamt sechs Prüfungsteilen keine Leistung unter zwei Punkten liegt und maximal eine Leistung unter fünf Punkten.',
            'Sollten zwei praktische Prüfungsteile mit weniger als fünf Punkten abgeschlossen werden, kann der Prüfling auf eigenen Wunsch zusätzlich mündlich geprüft werden. Bei Bestehen des mündlichen Prüfungsteils gilt die Prüfung als bestanden.',
          ],
        },
        {
          id: 'pruefungsunterlagen',
          title: '2.7. Prüfungsunterlagen',
          paragraphs: [
            'Auf Antrag ist dem Prüfling nach Abschluss der Prüfung Einsicht in seine Prüfungsunterlagen zu gewähren.',
          ],
        },
      ],
    },
    {
      id: 'pruefung',
      title: '3. Prüfung',
      defaultExpanded: true,
      children: [
        {
          id: 'schriftlicher-pruefungsteil',
          title: '3.1. Schriftlicher Prüfungsteil',
          paragraphs: [
            'Der schriftliche Prüfungsteil wird mit 1/3 der Gesamtnote gewertet. Es stehen 90 Minuten zur Verfügung.',
            'Es werden ca. 45 Fragen in unterschiedlichen Ausführungen gestellt (Freitext, Single- & Multiple-Choice-Fragen, Rechenaufgaben, ...).',
            'Der schriftliche Prüfungsteil kann ohne Anwesenheit der Prüfungskommission durchgeführt werden.',
            'Die Auswertung muss in Gänze durch zwei verschiedene Lehrhöhenretter*innen erfolgen. Alternativ kann dies auch durch Mitglieder*innen der Prüfungskommission erfolgen. Für die Auswertung soll eine Musterlösung genutzt werden.',
          ],
        },
        {
          id: 'praktischer-pruefungsteil',
          title: '3.2. Praktischer Prüfungsteil',
          paragraphs: [
            'Der praktische Prüfungsteil ist mehrteilig und wird mit insgesamt 2/3 der Gesamtnote gewertet. Für diesen Teil stehen ca. 135 Minuten zur Verfügung.',
            'Geprüft werden zwei Gruppenaufgaben, die Fitness- & Koordinationsfähigkeit, die Kameradenrettung und eine Einzelaufgabe.',
            'Die Aufgabenstellungen sind vor der Prüfung schriftlich zu fixieren und mit einer Bewertungsbeschreibung zu versehen.',
            'Für die Gruppenaufgaben gilt: Jedes Mitglied der Prüfungskommission beurteilt jeden Prüfling. Die Gruppenprüfungen sind so zu gestalten, dass jeder Prüfling nach seiner Einzelleistung beurteilt werden kann.',
            'Für die Einzelaufgabe gilt: Die Beurteilung des Prüfling erfolgt durch mindestens zwei Mitglieder*innen der Prüfungskommission.',
            'Sollte die Prüfungskommission während einer praktischen Teilprüfung einen so gravierenden Fehlleistung feststellen, dass bei weiterer Ausführung Gefahr für Leib & Leben besteht, kann diese bei Einstimmigkeit die Prüfung unverzüglich als „nicht bestanden“ erklären. Die Begründung hierüber ist schriftlich der Lehrgangsakte hinzuzufügen.',
          ],
        },
        {
          id: 'muendlicher-pruefungsteil',
          title: '3.3. Mündlicher Prüfungsteil',
          beforeGroupsParagraphs: [
            'Der mündliche Prüfungsteil findet auf Antrag des Prüflings statt, wenn zwei praktische Prüfungsteile mit „mangelhaft“ (2 bis 4 Punkte) abgeschlossen wurden, kein weiterer Prüfungsteil mit „mangelhaft“ und kein Prüfungsteil mit „ungenügend“ bewertet wurde, sowie die Gesamtnote mindestens „ausreichend“ ergibt.',
            'Der mündliche Prüfungsteil schließt zeitnah an das Ende der praktischen Prüfungsteile an und endet nach 20 Minuten.',
            'Der Prüfling wird in einem der als „mangelhaft“ bewerteten Prüfungsteil erneut geprüft.',
            'Der zu prüfende Prüfungsteil ergibt sich aus der Rangfolge:',
          ],
          groups: [
            {
              title: '',
              items: [
                '1. Kameradenrettung',
                '2. Person im Fallschutz',
                '3. Tragenrettung',
                '4. Fitness & Koordination',
                '5. Einzelüberprüfung',
              ],
            },
          ],
          afterGroupsParagraphs: [
            'Der/Die zu prüfende Teilnehmer*in erhält durch die Prüfungskommission die Aufgabenbeschreibung und anschließend fünf Minuten Zeit, sich Notizen zu machen.',
            'Für ein Bestehen muss der Prüfling erläutern können, wie der korrekte Arbeitsablauf der Aufgabe aussieht und welche sicherheitsrelevanten Aspekte bei der Abarbeitung zu beachten sind.',
            'Über den mündlichen Prüfungsteil ist ein Protokoll anzufertigen und der Lehrgangsakte beizulegen. Das Protokoll ist vom Prüfungsvorsitz und vom Prüfling zu unterzeichnen.',
          ],
        },
      ],
    },
    {
      id: 'schlusswort',
      title: '4. Schlusswort',
      defaultExpanded: false,
      paragraphs: [
        'Diese Ordnung ersetzt die bisherige Ausbildungs- & Prüfungsordnung der Höhenrettung und ist ein Anhang der Dienstanweisung Absturzsicherung & Höhenrettung vom 01.12.2022.',
      ],
    },
  ],
};
